var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-player-wrapper col-lg-10 col-12"},[_c('iframe',{staticClass:"media-player",attrs:{"data-qa":"media player","allowfullscreen":"true","src":_vm.localePath({ name: 'media', query: { id: _vm.itemId, mediaUrl: _vm.url, mediaType: _vm.format } }),"title":_vm.$t('record.mediaPlayer')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }